<template>
  <q-item
    v-bind="{ clickable, disable, dense, active, activeClass, tag, dark, insetLevel, tabindex, manualFocus, focused }"
    class="module-item"
    @click="$emit('click')"
  >
    <q-item-section
      v-if="licence.user && withProfileImage"
      side
    >
      <profile-image
        :profile-image="licence.user.profile_image"
        :initials="licence.user.initials"
        :color="licence.user.color"
      />
    </q-item-section>

    <q-item-section>
      <q-item-label>
        <span class="module-name">{{ licence.licence_number }}</span>
        <span v-if="licence.archived && withArchivedText" class="q-ml-sm text-red-7">Archived</span>
      </q-item-label>

      <q-item-label
        v-if="licence.descriptor"
      >
        {{ licence.descriptor }}
      </q-item-label>

      <q-item-label
        v-if="(withUser && licence.user) || licence.is_set_to_expire || (withExpiryDate && licence.expiry_date)"
        caption
      >
        <span v-if="withUser && licence.user" class="q-pr-sm">{{ licence.user.name }}</span>
        <span v-if="withExpiryDate && licence.expiry_date" class="q-pr-sm">
          {{ $formatDate(licence.expiry_date, luxonFormats.FRIENDLY_DATE) }}
        </span>
        <span v-if="licence.is_set_to_expire" class="text-bold text-red-7">{{ licence.is_set_to_expire }}</span>
      </q-item-label>
    </q-item-section>

    <q-item-section
      side
      class="q-pl-sm gt-xs text-right"
    >
      {{ licence.administrative_area }}, {{ licence.country }}
    </q-item-section>
    <q-item-section
      v-if="hasDefaultSlot"
      side
    >
      <slot />
    </q-item-section>
  </q-item>
</template>

<script>
import itemMixin from 'src/helpers/item'

export default {
  mixins: [itemMixin],
  props: {
    licence: {
      required: true,
      type: Object
    },
    withProfileImage: {
      type: Boolean,
      default: false
    },
    withArchivedText: {
      type: Boolean,
      default: false
    },
    withUser: {
      type: Boolean,
      default: false
    },
    withExpiryDate: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    hasDefaultSlot () {
      return !!this.$slots.default
    }
  }
}
</script>
